// LanguageCode component - replaces flags with ISO 639-1 codes
// This maintains the same interface as the old FlagIcon for drop-in replacement

interface FlagIconProps {
    code: string;
    className?: string;
    size?: 'sm' | 'md' | 'lg';
}

// Match original flag dimensions exactly
const SIZE_CONFIG = {
    sm: { width: 20, height: 14, fontSize: '10px' },
    md: { width: 24, height: 16, fontSize: '11px' },
    lg: { width: 28, height: 19, fontSize: '12px' },
};



// FlagIcon now renders ISO 639-1 codes in styled badges
export const FlagIcon = ({ code, className = '', size = 'md' }: FlagIconProps) => {
    const isoCode = code?.toUpperCase() || '';
    const config = SIZE_CONFIG[size];

    return (
        <span 
            className={`inline-flex items-center justify-center font-mono font-bold tracking-tight rounded-sm bg-green-100 text-green-700 border border-green-200 ${className}`}
            aria-label={code}
            title={code}
            style={{ 
                width: config.width, 
                height: config.height, 
                fontSize: config.fontSize,
                flexShrink: 0 
            }}
        >
            {isoCode}
        </span>
    );
};
